import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IInitializePasswordRequest } from '../../../../classes/initialize-password';
import { AppSettings } from '../../../../app.settings';

@Component({
	selector: 'create-code',
	template: require('./create-code.component.html'),
})
export class CreateCodeComponent {
	@Input() initRequest: IInitializePasswordRequest;
	@Input() public isLoginBigModalEnabled: boolean = false;
	public isRebrading = AppSettings.isRebrading;

	constructor(private activeModal: NgbActiveModal) {}

	toggleModalDialog(): void {
		this.activeModal.close();
	}
}
